import { RootState } from '@app/redux/root-reducer';

const slice = (state: RootState) => state.searchScreenReducer;

export const getSearchedItems = (state: RootState) => slice(state).searchedItems;
